import React from "react";
import "./refresh-token.scss";
import { Icons } from "../../atoms/Icons";
import { Link } from "react-router-dom";

const RefreshTokenModal = (props) => {
  return (
    <>
      <Link to="" className="text-end">
        <Icons
          iconname="close"
          variant="icon-twenty-four-px"
          clickHandler={props.handleCloseButton}
        />
      </Link>
      <p className="heading">{props.modalTitle}</p>
      <p>Please wait while we refresh the page.</p>
    </>
  );
};

export default RefreshTokenModal;
